<ion-header mode="ios">
  <ion-toolbar>
    <ion-title>Write a review</ion-title>
    <ion-button slot="start" color="dark" fill="clear" (click)="closeModal()">Cancel</ion-button>
  </ion-toolbar>
</ion-header>
<ion-content>

  <div sxPadding="medium">

    <div *ngIf="activeSlide == slides.selectParticipants" sxPadding="medium" sxBackground="light" sxRadius="medium" sxBorderWidth="1px" sxBorderColor="one">

      <h1>Whom you want to write a review</h1>

      <ion-list *ngIf="participants">
        <ion-item *ngFor="let participant of participants">
          <avatar-round [title]="participant.accountSnapshot.name" [imageUrl]="participant.accountSnapshot.displayPictureUrl"></avatar-round>
          <p>{{participant.accountSnapshot.name}}</p>
        </ion-item>
      </ion-list>

    </div>

    <div *ngIf="activeSlide == slides.writeReview" sxPadding="medium" sxBackground="light" sxRadius="medium" sxBorderWidth="1px" sxBorderColor="one">

      <div *ngIf="writingReviewForAccounts.length == 1" sxPadding="0 medium">
        <div *ngIf="writingReviewForAccounts[0] as participant" sxRow sxAlign="center" sxDistribution="start" sxGap="10px">
          <avatar-round [size]="30" [title]="participant.name" [imageUrl]="participant.displayPictureUrl"></avatar-round>
          <p>{{participant.name}}</p>
        </div>
      </div>

      <div sxRow sxPadding="medium" sxAlign="center" sxDistribution="spaceBetween" sxGap="10px">
        <div sxRow sxGap="10px" sxAlign="center">
          <ion-icon
            sxTextSize="34px"
            sxColor="three"
            sxCursor="pointer"
            *ngFor="let star of stars; let i = index"
            [name]="(i < hoveredRating) ? 'star' : 'star-outline'"
            (click)="rate(i + 1)"
            (mouseover)="hover(i + 1)"
            (mouseleave)="hover(0)"
            class="star-icon"
          ></ion-icon>
        </div>
        <p sxTextSize="large" sxMargin="0" *ngIf="rating > 0">{{rating}}</p>
      </div>

      <textarea sxMinHeight="200px" sxWidth="full" sxRadius="medium" sxBorderColor="one" sxBorderWidth="1px"
                sxPadding="medium" sxMargin="0 0 20px" [(ngModel)]="reviewText" maxlength="400"
      placeholder="Write your review here"
      ></textarea>

      <super-button iconEnd="chevron-forward" [showError]="true" [action]="onReviewSubmit">Submit</super-button>


    </div>

    <div *ngIf="activeSlide == slides.submitted"
         sxBackground="light" sxRadius="medium"
         sxPadding="medium" sxCol sxAlign="center" sxGap="10px">

      <ion-icon sxTextSize="44px" name="checkmark-circle" color="success"></ion-icon>
      <h4 sxMargin="10px 0 20px">Review Submitted</h4>
      <div sxRow sxAlign="center" sxDistribution="center" sxGap="5px">
        <ion-icon sxTextSize="large" name="star"></ion-icon>
        <p sxMargin="0">{{rating}} {{ rating > 1 ? 'stars' : 'star' }}</p>
      </div>

      <p *ngIf="reviewText?.length > 0" sxWidth="full" sxMinHeight="150px" sxPadding="medium" sxTextSize="small" sxBackground="light" sxRadius="medium" sxBorderWidth="1px" sxBorderColor="one">
        {{reviewText}}
      </p>

      <super-button sxWidth="full" sxMargin="20px 0 0" type="outline" size="small" (click)="closeModal()">Close</super-button>

    </div>

  </div>

</ion-content>
